<template>
  <div>
    <b-modal
        id="modal-aleave"
        cancel-variant="outline-secondary"
        centered
        ref="model-aleave"
        title="新增未轉堂數"
        no-close-on-backdrop
         scrollable
         hide-footer
      size="sm"
  >
      
        <b-form>
          <b-row>
              <!-- email -->

              <b-col cols="12">
                <b-form-group label="堂數" label-for="lesson">
                  <b-form-input id="lesson"  placeholder="只可以輸入數字" v-model="form_aleave.lesson" size="sm" />
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col cols="12" class="mt-1">
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mb-1" @click="add_class()" block>
                  確定
                </b-button>
              </b-col>
            </b-row>



        </b-form>
      </b-modal>
    <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-group>
          <v-select
            v-model="perPage"
            label="Number of rows"
            :options="pageOptions"
            :clearable="false"
          />
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="searchString"
            class="d-inline-block mr-1"
            placeholder="Search..."
          />
          <b-button
            variant="primary"
            v-b-modal.modal-aleave
            v-if="allow_imported === null"
          >
            <span class="text-nowrap">新增未轉堂數</span>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped
      class="mb-0"
      @row-selected="onRowSelected"
    >
      <template #cell(action)="data">
      <b-button size="sm" variant="outline-primary" v-if=" data.item.valid === true " @click="change_enrollment(data.item.enrollment_id)">
        轉堂
      </b-button>
      <!-- <b-button class="ml-1" size="sm" variant="outline-success" v-if="data.item.status != 'LEAVE'" @click="absent(data.item.enrollment_id)">
        請假
      </b-button> -->
    </template>
      <template #cell(class_datetime)="data">

          {{ data.item.class_date }} {{ data.item.start }}

      </template>
      <template #cell(amount)="data">
        HKD ${{data.item.amount}}
      </template>
    </b-table>
    <b-row>
      <b-col class="mt-1">
        Total : {{ totalRows }} , Display Row {{ startRow }} to {{ endRow }}
      </b-col>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          size="md"
          class="mt-1"
          @change="handleChangePage"
        />
      </b-col>
    </b-row>
  </b-card>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import PurchaseAddNew from './SidebarNewPurchase.vue'
import vSelect from 'vue-select'
import axios from "axios";
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import {
  BTable, BAvatar, BForm,BCard,BCardBody, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend, BModal, VBModal
} from 'bootstrap-vue'
import router from '@/router'
export default {
  components: {
    PurchaseAddNew,
    router,
    BTable,
    BAvatar,
    BBadge,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form_aleave: {
        lesson:null
      },
      deined:JSON.parse(localStorage.getItem('userData')),
      iframe_src : '//rb.cloudedu.pro/invoice.php',
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      planOptions: [
        { label: 'Basic', value: 'basic' },
        { label: 'Company', value: 'company' },
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Team', value: 'team' },
      ],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      centerOptions: [],
      transaction_id:null,
      allow_imported:false,
      transaction:null,
      isAddNewPurchaseSidebarActive: false,
      searchString: null,
      perPage: 10,
      startRow: 1,
      endRow: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      fields: [{ key: 'enrollment_id', label: '#' }, { key: 'center_name', label: '分校' }, { key: 'class_datetime', label: '時間' }, { key: 'todo_content', label: '作品' }, { key: 'expire_at', label: '限期' }, {key: 'action',label:'動作'}],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      status: [{
        1: 'Active', 2: 'Disabled', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-success', 2: 'light-danger', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      selectMode: 'single',
      selected: [],
    }
  },
  watch: {
    currentPage: {
      handler(newValue, oldValue) {
        this.get_data()
      },
    },
    searchString: {
      handler(newValue, oldValue) {
        // console.log("search")
        this.handleSearch()
      },
    },
    perPage: {
      handler(newValue, oldValue) {
        if (newValue < 9) {
          this.perPage = 10
        }
        // console.log("search")
        this.handleSearch()
      },
    },
  },
  created() {
    this.get_data()
  },
  methods: {
    absent(booking_id) {
      console.log(booking_id)
      return
      this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/' + booking_id + '/absent/')
        .then(res => {
          this.get_data()
        })
    },
    change_enrollment(id) {
      this.$router.push({path : '/class-list/' , query : { enrollment_id : id }} )
    },
    add_class() {
      this.$http.post(process.env.VUE_APP_API_BASE+'/student/' + router.currentRoute.params.id + '/aleave_init/add/',this.form_aleave)
        .then(res => {
          this.$refs['model-aleave'].hide()
          this.get_data()
        })
    },
    go_to_invoice() {
      this.$router.push('/apps/member/'+ router.currentRoute.params.id+'/class/add/')
    },
    one() {
      this.isAddNewMemberSidebarActive = false
      this.get_data()
    },
    get_data() {
       this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/aleave/`)
           .then(res => {
            this.allow_imported = res.data.allow_imported
          this.items = res.data.enrollments
          this.totalRows = res.data.enrollments.length
          this.startRow = res.data.startRow
          this.endRow = res.data.enrollments.length
          //  console.log( res.data.members.length)
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    handleChangePage() {

    //  this.get_data()
    },
    onRowSelected(items) {
      this.selected = items[0]

        this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../pdf/INVOICE_'+items[0].code+'.pdf'
        console.log(this.iframe_src)


      this.transaction_id = items[0].id
      this.$refs['my-modal'].show()
    },
    close() {
      this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../invoice.php'
      this.$refs['my-modal'].hide()
    },
    print() {
      this.iframe_src = process.env.VUE_APP_API_BASE+'/../../../invoice.php?print=y&code='+this.transaction_id
    },
    download() {
      window.location.href = '/../../../pdf/INVOICE_'+this.selected.code+'.pdf'
      //this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_'+items[0].code+'.pdf'
    },
    async downloadItem() {
      let t = '/pdf/INVOICE_'+this.selected.code+'.pdf'
      const response = await axios.get(t, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.selected.code;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    send() {
      this.$http.post(process.env.VUE_APP_API_BASE+'/transaction/'+this.selected.id+'/send/',{})
        .then(res => {
          this.$refs['my-modal'].hide()
        })
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2)
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2)
    },

    handleSearch() {
      // let _print = `The user searched for: ${searching}\n`
      // this.$refs.pre.appendChild(document.createTextNode(_print))
    // this.searchString = searching
    // this.currentx = 1
    // this.get_data()
      this.searchTimeOut()
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.get_data()
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
